import dayjs from 'dayjs'
import { UTC_TIME_ZONE } from '../assets/constants'

/**
 * DB検索用日付取得
 */
export const SearchDate = () => dayjs.tz(dayjs().toDate(), UTC_TIME_ZONE).toDate()

/**
 * 明日の日付取得
 */
export const getTomorrow = () => dayjs().add(1, 'day')

/**
 * YYYY.MM.DD HH:mmに変換する
 * @param date 日付
 */
export const convertDisplayDate = (date?: string | number | dayjs.Dayjs | Date | null | undefined) =>
  formatDate(date, 'YYYY.MM.DD HH:mm')

/**
 * 表示フォーマット形式の文字列に変換する
 * @param date 日付
 * @param format フォーマット
 */
export const formatDate = (date: string | number | dayjs.Dayjs | Date | null | undefined, format: string) =>
  dayjs(date).format(format)
